import { memo } from 'react'
import PropTypes from 'prop-types'
import './installation.scss'
import iphoneInstallIcon from 'assets/images/Iphone-direct-access/173.png'
import iphoneOption from 'assets/images/Iphone-direct-access/202422x.png'
import androidInstallIcon from 'assets/images/android-direct-access/20241.png'
import androidOption from 'assets/images/android-direct-access/17339.png'
import webInstallIcon from 'assets/images/web-direct-access/20243.png'

const InstallationInstructions = ({ classes = '', fromAndroid = true, fromMagenta = false }) => {
	const installIcon = fromAndroid ? androidInstallIcon : iphoneInstallIcon
	const optionIcon = fromAndroid ? androidOption : iphoneOption
	const altInstall = fromAndroid ? 'Botón de instalación Android' : 'Botón de instalación iPhone'
	const altOption = fromAndroid
		? 'Agregar a pantalla de inicio en Android'
		: 'Agregar a pantalla de inicio en iPhone'

	return (
		<div className={`m-installation ${classes}`}>
			<p className='m-installation__description'>
				Te recomendamos crear un ícono en la pantalla de inicio que te permita acceder fácilmente a
				Salud Continua.
			</p>
			{fromAndroid === null ? (
				<>
					<p className='m-installation__question'>
						1. Da clic en el botón{' '}
						<img
							src={webInstallIcon}
							alt={'Ícono de instalación web'}
							className='m-installation__icon'
						/>{' '}
						ubicado al final de la barra de la URL
					</p>
					<p className='m-installation__question'>
						2. Presiona el botón de instalar en la pantalla emergente
					</p>
					<p className='m-installation__question'>3. Mira el ícono en tu pantalla de inicio</p>
				</>
			) : fromAndroid && !fromMagenta ? (
				<>
					<p className='m-installation__question'>1. Da clic en el botón Crear ícono</p>
					<p className='m-installation__question'>
						2. Instala la aplicación y aprueba los permisos
					</p>
					<p className='m-installation__question'>
						3. Recibe la confirmación y mira el ícono en tu pantalla de inicio
					</p>
				</>
			) : (
				<>
					<p className='m-installation__question'>
						1. Da clic en el botón{' '}
						<img src={installIcon} alt={altInstall} className='m-installation__icon' /> ubicado en
						la esquina superior derecha
					</p>
					<p className='m-installation__question'>2. Selecciona la opción:</p>
					<img src={optionIcon} alt={altOption} className='m-installation__iphone' />
					<p className='m-installation__question'>3. Mira el ícono en tu pantalla de inicio</p>
				</>
			)}
		</div>
	)
}

InstallationInstructions.propTypes = {
	classes: PropTypes.string,
	fromAndroid: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf([null])]),
	useAndroidImages: PropTypes.bool
}

export default memo(InstallationInstructions)
